module.exports = __webpack_public_path__ + "img/hand-cursor-image.5a7ced57.svg";